import { getTotalPlanCost } from "~/helpers/numbers";
import { IPlan } from "~/types/billing";
import { IProduct } from "~/types/dropshipping";
import { triggerGtagPurchaseEvent, triggerStartedTrialEvent } from "./gtag";
import { getGclid } from "./analytics";

// export function triggerBingAdsEvent(
//   eventName: string,
//   eventData: Record<string, any>
// ) {
//   if (typeof window === "undefined") {
//     return;
//   }

//   // @ts-ignore
//   window.uetq = window.uetq || [];
//   // @ts-ignore
//   window.uetq.push(["event", eventName, eventData]);
// }

const triggerGtagEvent = (eventData: {
  event: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  value?: string;
}) => {
  // if (!import.meta.env.VITE_GOOGLE_TAG_KEY) {
  //   const { event, ...rest } = eventData;
  //   console.log(`[GTM Event - ${event}]`, rest);
  //   return;
  // }

  // @ts-ignore
  if (window.dataLayer) {
    const gclid = getGclid();
    if (gclid) {
      // @ts-ignore
      eventData.gclid = gclid;
    }

    console.log("eventData", eventData);

    // @ts-ignore
    window.dataLayer.push(eventData);
  }
};

export const triggerGTMPlanSubscription = (plan: IPlan) =>
  triggerGtagPurchaseEvent(plan);
// triggerGtagEvent({
//   event: `subscription_${plan.name.split(" ")[0]}_${plan?.interval}`,
//   event_category: `subscription_${plan.name.split(" ")[0]}`,
//   event_action: `subscription_${plan.interval}`,
//   event_label: `subscription_${plan.name.split(" ")[0]}`,
//   value: `${plan.name} - ${plan?.interval} - ${getTotalPlanCost(plan)}`,
// });

export const triggerGTMAddToImportList = (product: IProduct) =>
  triggerGtagEvent({
    event: "Added to Import List",
    value: `(${product.id}) ${product.title}`,
  });

export const triggerGTMAddPaymentInfo = () =>
  triggerGtagEvent({ event: "AddPaymentInfo" });

export const triggerGTMBulkCheckout = (subOrderIds: number[]) =>
  triggerGtagEvent({
    event: "Bulk Checkout (dropshipping)",
    value: subOrderIds.map((id) => id.toString()).join(", "),
  });

export const triggerGTMUpgrade = (plan: IPlan) =>
  triggerGtagEvent({
    event: `buttonUpgrade${plan.name.split(" ")[0]}`,
    event_category: `upgrade_subscription_${plan.name.split(" ")[0]}`,
    event_action: `upgrade_subscription_${plan.interval}`,
    event_label: `upgrade_subscription_${plan.name.split(" ")[0]}`,
    value: `${plan.name} - ${plan?.interval} - ${getTotalPlanCost(plan)}`,
  });

export const triggerGTMDirectSignup = () =>
  triggerGtagEvent({
    event: "Sign Up (Direct)",
  });

export const triggerGTMSignup = () =>
  triggerGtagEvent({
    event: "Sign Up (Landing Page)",
  });

export const triggerGTMDowngrade = (plan: IPlan) =>
  triggerGtagEvent({
    event: "Downgrade",
    event_category: `downgrade_subscription_${plan.name.split(" ")[0]}`,
    event_action: `downgrade_subscription_${plan.interval}`,
    event_label: `downgrade_subscription_${plan.name.split(" ")[0]}`,
    value: `${plan.name} - ${plan?.interval} - ${getTotalPlanCost(plan)}`,
  });

export const triggerGTMPausePlan = (plan: IPlan) =>
  triggerGtagEvent({
    event: "Pause Plan",
    event_category: `pause_subscription_${plan.name.split(" ")[0]}`,
    event_action: `pause_subscription_${plan.interval}`,
    event_label: `pause_subscription_${plan.name.split(" ")[0]}`,
    value: `${plan.name} - ${plan?.interval} - ${getTotalPlanCost(plan)}`,
  });

// export const triggerGTMStartTrial = () => triggerStartedTrialEvent();

export const triggerGTMStartTrial = (plan: IPlan) =>
  triggerGtagEvent({
    event: "Start Trial",
    event_category: `start_trial_subscription_${plan.name.split(" ")[0]}`,
    event_action: `start_trial_subscription_${plan.interval}`,
    event_label: `start_trial_subscription_${plan.name.split(" ")[0]}`,
    value: `${plan.name} - ${plan?.interval} - ${getTotalPlanCost(plan)}`,
  });

export const triggerCheckoutPageView = () => {
  try {
    // @ts-ignore
    window.gtag("event", "conversion", {
      send_to: "AW-11563267581/UjMwCNWgq4oaEP3r5Ykr",
      value: "39.99",
      currency: "USD",
      transaction_id: "",
    });
  } catch (err) {
    console.log(err);
  }
};
